<template>
	<div>
		<!-- Premium Loadings -->
		<div
			class="xs-12 p3 bb1 bc7"
			v-if="computedLoadings.length > 0 || hasLoadingsActions"
		>
			<div class="xs-12 fs3 lh125 fw7 c1">{{ $t("premium_loadings") }}</div>
			<j-list
				:list="computedLoadings"
				class="b1 bc7 mt2"
				v-if="computedLoadings.length > 0"
			>
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">{{ item.label }}</div>
					<div class="flex xs-6 xs-right xs-middle lh125">
						<div class="mr3 xs-right ta3">
							<div class="lh125">{{ item.value }}</div>
							<div class="c6 lh125">{{ item.summary }}</div>
						</div>
						<div v-if="hasLoadingsActions">
							<crm-icon
								name="delete"
								class="cu2"
								color="cError"
								size="small"
								@click.native="removeLoading(item.id)"
							/>
						</div>
					</div>
				</div>
			</j-list>

			<!-- Add button and loading state -->
			<div class="flex xs-12 xs-between" v-if="hasLoadingsActions">
				<j-button
					v-can:or="['writeQuotes', 'writePolicies']"
					size="xsmall"
					class="mt2"
					@click="$modal.show(`addLoading_${computedId}`)"
					action="addLoading"
				>{{ $t("add_loading") }}</j-button>
			</div>
		</div>
		<!-- Modal for adding loading -->
		<core-modal :name="`addLoading_${computedId}`" :headline="$t('add_loading')">
			<premium-loading-create
				:productId="productId"
				:addLoading="addLoading"
				@cancelled="$modal.hide(`addLoading_${computedId}`)"
			/>
		</core-modal>
	</div>
</template>

<script>
import get from "lodash.get"
import CoreModal from "@/modules/core/components/CoreModal"
import JList from "@/components/JList"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import PremiumLoadingCreate from "./PremiumLoadingCreate"

export default {
	components: {
		CoreModal,
		JButton,
		JList,
		CrmIcon,
		PremiumLoadingCreate
	},
	props: {
		id: {
			type: String
		},
		productId: {
			type: Object
		},
		pricing: {
			type: Object
		},
		hasLoadingsActions: {
			type: Boolean,
			required: false,
			default: false
		},
		addLoading: {
			type: Function,
			required: false
		},
		removeLoading: {
			type: Function,
			required: false
		}
	},

	computed: {
		computedLoadings() {
			const loadings = get(this, "pricing.loadings", [])
			if (!loadings) return []

			/**
			 * Helper function that accepts loading type
			 * and decides whether to show flat or ratio
			 */
			const getValue = item => {
				if (!item) return ""
				const ratio = item.ratio ? `${(item.ratio * 100).toFixed(2)}%` : null
				const flat = item.flat
					? `${get(this, "pricing.currencyCode", "") || ""}${item.flat
							.toFixed(2)
							.replace(/\d(?=(\d{3})+\.)/g, "$&,")}`
					: "0"
				return {
					flat,
					summary: ratio
						? `(${ratio} of ${this.pricing.formattedOriginalPrice || this.pricing.formattedPrice})`
						: ""
				}
			}
			return loadings.map(loading => ({
				id: loading.id,
				label: loading.codeName.name || loading.codeName.code || "----",
				value: getValue(loading).flat,
				summary: getValue(loading).summary
			}))
		},

		computedId() {
			return this.id
		}
	}
}
</script>
